(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fc-product-animation"] && !Shopify.designMode) return;
  try {
    // Plays the loop only while it is on screen, which is also what keeps the
  // file from being downloaded at all until someone scrolls to it. Doubles as
  // the reduced-motion switch: a visitor who has asked for less motion simply
  // never gets a play() call. An animated GIF can do none of this, which is one
  // more reason to prefer MP4.
  (() => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          if (isIntersecting) {
            // Rejects on its own if the tab is backgrounded or the decode
            // fails. Nothing to recover, so let it go quietly.
            target.play().catch(() => {});
          } else {
            target.pause();
          }
        });
      },
      { rootMargin: '200px' }
    );

    const observe = () => {
      document
        .querySelectorAll('video.fc-product-animation__media')
        .forEach((video) => observer.observe(video));
    };

    observe();
    // Section rendering in the theme editor replaces the markup wholesale.
    document.addEventListener('shopify:section:load', observe);
  })();
  } catch(e) { console.error(e); }
})();

})();
